
class LimitTitle {
    [x: string]: any;
}

export default {
    controller: LimitTitle,
    template : require('./limit.title.html'),
    bindings: {title: "<", description: "<", count: "<"}
}

